<template>
  <div v-if="showedAdminPopUp.active" class="admin-popup" @click.self="hideAlert" tabindex="0">
    <div class="admin-popup-background">
    </div>
    <div class="admin-popup-container" :style="showedAdminPopUp.info.background ? 'background-color:' + showedAdminPopUp.info.background + ';' : ''">
      <div @click="hideAlert" class="close"></div>
        <div class="admin-popup-container-inner" :style="showedAdminPopUp.info.scrollable ? '' : 'overflow:hidden;'">
          <component :is="processedHtml"></component>
          <div v-if="showedAdminPopUp.info.show_bottom_button" class="admin-popup-container-inner-accept_button">
            <a @click="hideAlert" class="btn btn-primary">{{showedAdminPopUp.info.button_title ? showedAdminPopUp.info.button_title : trans('ok')}}</a>
          </div>
        </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import { h } from 'vue'
import VideoPlayer from "@buddy/views/widgets/VideoPlayer";
export default {
  mixins: [require('@general/lib/mixin').default],
  components: {VideoPlayer},
  computed: {
    ...mapState({
      showedAdminPopUp : 'showedAdminPopUp'
    }),
    processedHtml(){
      let text = !app.isMobile && this.showedAdminPopUp.info.text_desktop ? this.showedAdminPopUp.info.text_desktop : this.showedAdminPopUp.info.text;
      let html = text ? text.replace(/\[video-\d+]/g, ($0) => `<VideoPlayer v-bind:in_popup="true" v-bind:poster="'${this.showedAdminPopUp.info.videos[$0.match(/\d+/)]['thumb_orig']}'" v-bind:videoSource="{'webm' : '${this.showedAdminPopUp.info.videos[$0.match(/\d+/)]['video_url']['webm']}','mp4': '${this.showedAdminPopUp.info.videos[$0.match(/\d+/)]['video_url']['mp4']}'}" ></VideoPlayer>`) : '';
      /*return {
        template: '<div>' + html + '</div>'
      }*/
      return{
        components:{VideoPlayer},
        template: `<div style="height:100%;">${html}</div>`
      };
    },
  },
  props: [],
  methods: {
    hideAlert() {
      this.$store.dispatch('closeAdminPopUp',{popup:this.showedAdminPopUp.info,page:this.showedAdminPopUp.page})
    },
  },
}
</script>
